import { SyncPullFailedError } from '../../sync/core/syncPullErrors';

export const shouldSkipRemoteSnapshotDueToStockQueue = (params: {
  force: boolean;
  stockSyncPending: boolean;
}): boolean => params.force === true && params.stockSyncPending;

/**
 * Fallo remoto con la pantalla sin datos para mostrar (cache vacía) o en un
 * pull explícito (force) → propagar para que la UI pinte error + Reintentar.
 * Con cache con datos el error se traga y se sirve la cache: un fallo remoto
 * NUNCA debe leerse como "lista vacía" (falso empty state).
 */
export const shouldPropagateCatalogReadError = (params: {
  effectiveForce: boolean;
  error: unknown;
}): boolean =>
  params.effectiveForce === true && params.error instanceof SyncPullFailedError;
